function calculateStamitaWithTarget(now, currentStaminaStr, targetDateStr) {
  let currentHours = parseInt(currentStaminaStr.substring(0, 2), 10);
  let currentMinutes = parseInt(currentStaminaStr.substring(3, 5), 10);

  const targetHour = parseInt(targetDateStr.substring(0, 2), 10);
  const targetMinutes = parseInt(targetDateStr.substring(3, 5), 10);

  let targetDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), targetHour, targetMinutes, 0, 0);

  if (now.getHours() > targetHour) {
    targetDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, targetHour, targetMinutes, 0, 0);
  }

  const hours = Math.abs(targetDate - now) / 36e5;

  if ((currentMinutes > 60) || (targetMinutes > 60)) {
    return 'invalid input';
  }
  if (currentHours >= 42) {
    return '0';
  }

  // eslint-disable-next-line radix
  let hoursRemaining = parseInt(hours, 0, 2);
  // eslint-disable-next-line radix
  const min = parseInt(hours.toString().split('.')[1].slice(0, 2), 0, 0);
  let minutesRemaining = ((min / 100) * 60).toFixed(0);

  let qtdToBonus = (39 - currentHours) * 3;
  let qtdToFull = (42 - (currentHours + (qtdToBonus < 0 ? 0 : qtdToBonus))) * 6;

  console.log('qtdToBonus', qtdToBonus);
  console.log('qtdToFull', qtdToFull);

  while (qtdToBonus > 0 && hoursRemaining > 3) {
    qtdToBonus -= 1;
    currentHours += 1;
    hoursRemaining -= 3;
  }

  while (qtdToFull > 0 && hoursRemaining > 6) {
    qtdToFull -= 1;
    currentHours += 1;
    hoursRemaining -= 6;
  }

  minutesRemaining = (hoursRemaining * 60) + parseInt(minutesRemaining, 10) + 1;
  console.log('hoursRemaining', hoursRemaining);
  console.log('minutesRemaining', minutesRemaining);

  while (currentHours < 39 && minutesRemaining >= 3) {
    minutesRemaining -= 3;
    currentMinutes += 1;
    if (currentMinutes === 60) {
      currentMinutes = 0;
      currentHours += 1;
    }
  }

  while (currentHours >= 39 && minutesRemaining >= 6) {
    minutesRemaining -= 6;
    currentMinutes += 1;
    if (currentMinutes === 60) {
      currentMinutes = 0;
      currentHours += 1;
    }
  }

  if (currentHours >= 42) {
    currentHours = 42;
    currentMinutes = 0;
  }
  if (currentMinutes < 10) {
    currentMinutes = `0${currentMinutes}`;
  }

  return `${currentHours}:${currentMinutes}`;
}

export default calculateStamitaWithTarget;
